/* merchant/reducer */
import { createReducer } from "typesafe-actions";
import { MerchantActionTypes, MerchantState } from "./types";
import {
  fetchRequest,
  fetchSuccess,
  fetchAllSuccess,
  fetchError,
  saveRequest,
  saveSuccess,
  saveError,
  deleteRequest,
  deleteSuccess,
  deleteError,
  updateState,
} from "./actions";

export const initialState: MerchantState = {
  data: undefined,
  dataAll: undefined,
  errors: undefined,
  loading: false,
};

type ActionType =
  | ReturnType<typeof fetchRequest>
  | ReturnType<typeof fetchSuccess>
  | ReturnType<typeof fetchAllSuccess>
  | ReturnType<typeof fetchError>
  | ReturnType<typeof saveRequest>
  | ReturnType<typeof saveSuccess>
  | ReturnType<typeof saveError>
  | ReturnType<typeof deleteRequest>
  | ReturnType<typeof deleteSuccess>
  | ReturnType<typeof deleteError>
  | ReturnType<typeof updateState>;

export default createReducer<MerchantState, ActionType>(initialState)
  .handleType(MerchantActionTypes.FETCH, (state) => {
    return { ...state, loading: true, data: undefined, errors: undefined };
  })
  .handleType(MerchantActionTypes.FETCH_SUCCESS, (state, action) => {
    return {
      ...state,
      loading: false,
      data: action.payload,
      errors: undefined,
    };
  })
  .handleType(MerchantActionTypes.FETCHALL_SUCCESS, (state, action) => {
    return {
      ...state,
      loading: false,
      dataAll: action.payload,
      errors: undefined,
    };
  })
  .handleType(MerchantActionTypes.FETCH_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      data: undefined,
      errors: action.payload,
    };
  })
  .handleType(MerchantActionTypes.SAVE_REQUEST, (state) => {
    return { ...state, loading: true, errors: undefined };
  })
  .handleType(MerchantActionTypes.SAVE_SUCCESS, (state, action) => {
    return {
      ...state,
      loading: false,
      data: action.payload,
      errors: undefined,
    };
  })
  .handleType(MerchantActionTypes.SAVE_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      errors: action.payload,
    };
  })
  .handleType(MerchantActionTypes.DELETE_REQUEST, (state) => {
    return { ...state, loading: true, errors: undefined };
  })
  .handleType(MerchantActionTypes.DELETE_SUCCESS, (state) => {
    return {
      ...state,
      loading: false,
      errors: undefined,
    };
  })
  .handleType(MerchantActionTypes.DELETE_ERROR, (state, action) => {
    return {
      ...state,
      loading: false,
      errors: action.payload,
    };
  })
  .handleType(MerchantActionTypes.UPDATE_STATE, (state, action) => {
    return {
      ...state,
      loading: false,
      errors: undefined,
      data: {
        errors: undefined,
        data: action.payload,
        dataAll: undefined,
        meta: {
          totalObjects: action.payload.length,
        },
      },
    };
  });
